ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
ConnectStore = require 'components/enhancers/connect_store'
{ mdgFormat } = require 'lib/references_utils'
MDGTableActions = require 'actions/mdg_table_actions'
MDGTableStore = require 'stores/mdg_table_store'
Modal = require 'components/common/modal'
ReferencesStore = require 'stores/references_store'
{ useCoffeeCallback, useCoffeeMemo, useI18n } = require 'lib/react_utils'

storeConnector =
  MDGTableStore: (Store) ->
    applying: Store.getParentDialogIsApplying()
    currentStudyId: Store.getParentDialogCurrentStudyId()
    questionId: Store.getCurrentQuestion().get '_id'
    selectedStudyId: Store.getParentDialogSelectedStudyId()
    studiesForParentDialog: Store.getStudiesForParentDialog()
    dialogType: Store.getParentDialogType()
  ReferencesStore: (Store) ->
    references: Store.getReferences()

ParentStudySelector = ({
  applying
  currentStudyId
  questionId
  references
  selectedStudyId
  studiesForParentDialog
  dialogType
}) ->

  i18n = useI18n 'mdg_tables:parent_study_selector_dialog'

  formatReference = useCoffeeCallback [references], (referenceId) ->
    reference = references.find (reference) -> reference.get('_id') is referenceId
    return '' unless reference
    mdgFormat reference.toJS()

  onSelect = useCoffeeCallback [], (studyId) -> (e) ->
    e.stopPropagation()
    MDGTableActions.selectParentStudy studyId

  onApply = useCoffeeCallback [currentStudyId, questionId, selectedStudyId], ->
    if dialogType is 'merge'
      MDGTableActions.mergeStudy questionId, currentStudyId, selectedStudyId
    else
      MDGTableActions.connectParentStudy questionId, currentStudyId, selectedStudyId

  <Modal
    className="parent-study-selector-dialog"
    isOpen={currentStudyId?}
    modalSize="medium"
    title={i18n "title_#{dialogType}"}
  >
    <div className="parent-study-selector-dialog__description">
      {i18n "description_#{dialogType}"}
    </div>
    <div className="parent-study-selector-dialog__selection">
      {studiesForParentDialog.isEmpty() and <div className="selection__no-studies">
        {i18n 'no_studies'}
      </div>}
      {studiesForParentDialog.map (study) ->
        studyId = study.get 'id'
        <div className="selection__item" key={studyId} onClick={onSelect studyId}>
          <div className="item__radio">
            <input
              checked={selectedStudyId is studyId}
              name="parent-study-selector"
              onChange={onSelect studyId}
              type="radio"
            />
          </div>
          <div className="item__study-name">
            {formatReference study.get 'referenceId'}
          </div>
        </div>
      }
    </div>
    <ApplyCancelButtons
      applying={applying}
      isSubmitEnabled={selectedStudyId?}
      onApply={onApply}
      onCancel={MDGTableActions.closeParentStudyDialog}
    />
  </Modal>

ParentStudySelector.propTypes =
  applying: PropTypes.bool.isRequired
  currentStudyId: PropTypes.string
  selectedStudyId: PropTypes.string
  studies: PropTypes.instanceOf(Immutable.List).isRequired

ParentStudySelector.defaultProps =
  currentStudyId: null
  selectedStudyId: null

module.exports = ConnectStore ParentStudySelector, [MDGTableStore, ReferencesStore], storeConnector
